import { environment } from "../../config";
import {
  DeletedRolePermission,
  iDataRolePermissions,
} from "../../interfaces/SuperAdmin/Pages/iDataRolePermissions";
import {
  EditRoleFields,
  iDataRoles,
  PostRoleFields,
} from "../../interfaces/SuperAdmin/Pages/iDataRoles";
import {
  DeletedUserRole,
  iDataUserRoles,
} from "../../interfaces/SuperAdmin/Pages/iDataUserRoles";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

/* 
------------------------------------------------- 
ROL
-------------------------------------------------
*/

export const getRolesByOrgId = (id: string) =>
  fetchData<iDataRoles[]>({
    method: "GET",
    url: `${baseApiBroker}/rol`,
    params: {
      ...{ id_organizacion: id },
    },
  });

export const getRoleById = (id: string) =>
  fetchData<iDataRoles>({
    method: "GET",
    url: `${baseApiBroker}/rol/${id}`,
  });

export const postRole = (data: PostRoleFields) =>
  fetchData<{ id_rol: string }>({
    method: "POST",
    url: `${baseApiBroker}/rol`,
    data,
  });

export const deleteRoleById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/rol/${id}`,
  });

export const putRoleById = (data: EditRoleFields, id: string) =>
  fetchData<iDataRoles>({
    method: "PUT",
    url: `${baseApiBroker}/rol/${id}`,
    data,
  });

/* 
------------------------------------------------- 
COMPONENTE-ROL
-------------------------------------------------
*/

export const getAppsInRole = (id_rol: string) =>
  fetchData<iDataRolePermissions[]>({
    method: "GET",
    url: `${baseApiBroker}/rol-permiso-comp`,
    params: { id_rol, permiso: "VER" },
  });

export const postAppsInRole = (data: {
  id_rol: string;
  id_componentes: string[];
}) =>
  fetchData<iDataRolePermissions[]>({
    method: "POST",
    url: `${baseApiBroker}/rol-permiso-comp`,
    data,
  });

export const deleteAppsInRole = (data: { ids: string[] }) =>
  fetchData<DeletedRolePermission[]>({
    method: "DELETE",
    url: `${baseApiBroker}/rol-permiso-comp`,
    data,
  });

/* 
------------------------------------------------- 
USUARIO-ROL
-------------------------------------------------
*/

export const getUsersInRole = (id_rol?: string, id_usuario?: string) =>
  fetchData<iDataUserRoles[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario-rol`,
    params: {
      ...(id_rol && { id_rol }),
      ...(id_usuario && { id_usuario }),
    },
  });

export const postUsersInRole = (data: {
  id_rol: string;
  id_usuarios: string[];
}) =>
  fetchData<iDataUserRoles[]>({
    method: "POST",
    url: `${baseApiBroker}/usuario-rol`,
    data,
  });

export const deleteUsersInRole = (data: { ids: string[] }) =>
  fetchData<DeletedUserRole[]>({
    method: "DELETE",
    url: `${baseApiBroker}/usuario-rol`,
    data,
  });

export const ADMINS_DE_DOMINIO: Record<string, string> = {
  close: "6f6c4d48-8741-4853-b152-d2d2246699d7",
  open: "6f6fa569-1dab-4177-9d51-a8dc157466fa",
};
